import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import { Routes } from '../../core/routes/apiRoutes'
import serviceUserService from './serviceUserService'

const initialState = {
    data: null,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: '',
    errors: null,
}

//Get - Requires Admin Authentication
export const getServiceUsers = createAsyncThunk(Routes.getServiceUsersUrl, async ( url, thunkAPI) => {
    try{
        return await serviceUserService.getServiceUsers(url);
    }catch (error) {
        var errorData = {message: (error.response && error.response.data && error.response.data.message) || error.message || error.toString()}
        if(error.response.status === 422){
            errorData['errors'] = error.response.data.errors;
            
        }
        return thunkAPI.rejectWithValue(errorData);
    }
})

//Get - Requires Admin Authentication
export const getServiceUserProfile = createAsyncThunk(Routes.getServiceUsersUrl+"/profile", async (id, thunkAPI) => {
    try{
        return await serviceUserService.getProfile(id);
    }catch (error) {
        var errorData = {message: (error.response && error.response.data && error.response.data.message) || error.message || error.toString()}
        if(error.response.status === 422){
            errorData['errors'] = error.response.data.errors;
            
        }
        return thunkAPI.rejectWithValue(errorData);
    }
})

//delete - Requires Admin Authentication
export const deleteServiceUser = createAsyncThunk(Routes.getServiceUsersUrl+"/delete", async ( email, thunkAPI) => {
    try{
        return await serviceUserService.deleteServiceUser(email);
    }catch (error) {
        var errorData = {message: (error.response && error.response.data && error.response.data.message) || error.message || error.toString()}
        if(error.response.status === 422){
            errorData['errors'] = error.response.data.errors;
            
        }
        return thunkAPI.rejectWithValue(errorData);
    }
})

export const serviceUserSlice = createSlice({
    name: 'serviceUser',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = false;
            state.message = '';
            state.errors = null;
        }
    }, 
    extraReducers: (builder) => {
        function sharedRejectedReducer(state, action){
            state.isLoading = false
            state.isError = true
            state.message = action.payload.message
            state.errors = action.payload.errors
        }
        function sharedPendingReducer(state, action){
            state.isLoading = true
        }

        builder
       
        .addCase(getServiceUsers.pending,sharedPendingReducer)
        .addCase(getServiceUsers.rejected, sharedRejectedReducer)
        .addCase(deleteServiceUser.pending,sharedPendingReducer)
        .addCase(deleteServiceUser.rejected, sharedRejectedReducer)
        .addCase(getServiceUserProfile.pending,sharedPendingReducer)
        .addCase(getServiceUserProfile.rejected, sharedRejectedReducer)

         //Get
         .addCase(getServiceUsers.fulfilled, (state,action) => {
            state.isLoading = false
            state.isSuccess = true
            state.isError = false
            state.data = action.payload
            state.errors = null

        })

        //Get
        .addCase(getServiceUserProfile.fulfilled, (state,action) => {
            state.isLoading = false
            state.isSuccess = true
            state.isError = false
            state.data = action.payload
            state.errors = null

        })

         //Delete
         .addCase(deleteServiceUser.fulfilled, (state,action) => {
            state.isLoading = false
            state.isSuccess = true
            state.message = action.payload.message
            state.isError = false
            state.errors = null
        })
    }
})

export const {reset} = serviceUserSlice.actions
export default serviceUserSlice.reducer